<template>
    <div class="login__error">
        <div class="login__error-title">
            <IconAlert />
            <span v-html="title" />
        </div>
        <div class="login__error-text"
             v-html="blockText || text" />

        <!-- Если есть ограничение на количество попытов и попытки ещё есть -->
        <template v-if="isCount && count > 0">
            <div class="login__error-count">
                Осталось попыток: {{ count }}
            </div>

            <div class="login__form-submit">
                <button type="button"
                        :disabled="!isCanSend"
                        class="button button_theme_white button_full_width"
                        @click="changeAttemptCount">
                    <span class="button__text">
                        Попробовать ещё раз
                        <span v-if="!isCanSend">
                            через
                            <!-- 5 секунд -->
                            <STCountdown :time="5*1000"
                                         @end="isCanSend = true" />
                        </span>
                    </span>
                </button>
            </div>
        </template>

        <!-- Иначе, если количество попыток кончилось, ничего не выводим кроме текста выше -->
        <template v-else-if="count <= 0" />

        <!-- Иначе, если есть таймер до конца ошибки -->
        <div v-else-if="isTimer"
             class="login__error-timer">
            <span class="login__error-timer-text">До разблокировки осталось</span>
            <span class="login__error-timer-time">
                <STCountdown :time="minutes * 60 * 1000"
                             @end="clearBlock" />
            </span>
        </div>

        <!-- Иначе, показываем кнопку скрытия ошибки -->
        <div v-else
             class="login__error-button">
            <STBaseButton text="Вернуться назад"
                          modify="button_full_width button_theme_white"
                          @click="close" />
        </div>
    </div>
</template>

<script>
import IconAlert from '@/components/Icons/Alert';
import {mapGetters} from 'vuex';
import moment from 'moment';

export default {
    name: 'LoginErrors',

    components: {
        IconAlert
    },

    props: {
        title  : String,
        text   : String,
        minutes: {
            type   : Number,
            default: 20
        },
        isTimer: {
            type   : Boolean,
            default: false
        },
        isCount: {
            type   : Boolean,
            default: false
        }
    },

    data() {
        return {
            isCanSend: false, // Можно ли отправить запрос снова
            blockText: null
        };
    },

    computed: {
        ...mapGetters({
            count: 'GET_LOGIN_ATTEMPT_COUNT'
        })
    },

    created() {
        if (!this.isTimer) {
            return;
        }

        const storedText = localStorage.getItem('blockText');

        if (storedText) {
            this.blockText = storedText;
        } else {
            localStorage.setItem('blockText', String(this.text));
            this.blockText = this.text;
        }

        const blockStart = localStorage.getItem('blockStart');
        const blockTerm = localStorage.getItem('blockTerm');

        if (blockStart && blockTerm) {
            return;
        }
        
        localStorage.setItem('blockStart', String(moment(new Date())));
        localStorage.setItem('blockTerm', String(this.minutes));
    },

    methods: {
        close() {
            this.$emit('clearError');
        },
    
        /**
         * Переход к предыдущему шагу чистя ошибку
         */
        clearBlock() {
            localStorage.removeItem('blockTerm');
            localStorage.removeItem('blockText');
            localStorage.removeItem('blockStart');
            this.blockText = null;
            this.close();
        },

        changeAttemptCount() {
            this.$store.dispatch('changeCountLoginAttempt');
            this.close();
        }
    }
};
</script>
